import axiosInstance from '@/api/http';
import { IResponse } from '@/api/IResponse';
import CreateServiceConfigModel from '@/models/createServiceConfigModel';

export default class ServiceCodeService {
  /**
   * @description: 查询全部serviceCode
   * @return {Promise}
   */
  static getAll = (): Promise<IResponse> => axiosInstance.get('serviceconfig').then((res) => res.data);

  /**
   * @description: 新增serviceCode
   * @param {CreateServiceConfigModel} params
   * @return {Promise}
   */
  static create = (params: CreateServiceConfigModel): Promise<IResponse> => axiosInstance.post('serviceconfig', params).then((res) => res.data);

  /**
   * @description: 查询指定serviceCode的信息
   * @return {Promise}
   */
     static get = (serviceCode:string): Promise<IResponse> => axiosInstance.get(`serviceconfig/${serviceCode}`).then((res) => res.data);
}
